import { useNetworkFormContext } from "../../context/NetworkFormContext";

const useSubnetsValidation = () => {
  const {
    formData: { completeCreate, subnets },
  } = useNetworkFormContext();

  if (!completeCreate || !subnets?.length) return null;

  const isSingleSubnet = subnets.length === 1;

  for (let i = 0; i < subnets.length; i++) {
    const subnet = subnets[i];

    if (subnet.ipVersion === 4) {
      if (!subnet.cidr.trim()) {
        return isSingleSubnet
          ? {
              message: "Please provide a valid CIDR value for the subnet.",
              refIndex: i,
            }
          : {
              message: `Please provide a valid CIDR value for subnet ${subnet.name || `#${i + 1}`}.`,
              refIndex: i,
            };
      }

      if (subnet.enableGateway && !subnet.gatewayIp.trim()) {
        return isSingleSubnet
          ? {
              message:
                "Please provide a valid Gateway IP value for the subnet.",
              refIndex: i,
            }
          : {
              message: `Please provide a valid Gateway IP value for subnet ${subnet.name || `#${i + 1}`}.`,
              refIndex: i,
            };
      }

      if (
        subnet.enableDhcp &&
        subnet.allocationPools.some(
          (pool) => !pool.end.trim() || !pool.start.trim(),
        )
      ) {
        return isSingleSubnet
          ? {
              message:
                "Please provide valid allocation pools values for for the subnet.",
              refIndex: i,
            }
          : {
              message: `Please provide valid allocation pools values for for subnet ${subnet.name || `#${i + 1}`}.`,
              refIndex: i,
            };
      }
    }

    if (!subnet.dnsNameservers.trim()) {
      return isSingleSubnet
        ? {
            message: "Please provide valid nameserver values for the subnet.",
            refIndex: i,
          }
        : {
            message: `Please provide valid nameserver values for subnet ${subnet.name || `#${i + 1}`}.`,
            refIndex: i,
          };
    }

    if (
      subnet.enableHostRoutes &&
      subnet.hostRoutes.some(
        (route) => !route.destination.trim() || !route.nexthop.trim(),
      )
    ) {
      return isSingleSubnet
        ? {
            message: "Please provide valid host routes values for the subnet.",
            refIndex: i,
          }
        : {
            message: `Please provide valid host routes values for subnet ${subnet.name || `#${i + 1}`}.`,
            refIndex: i,
          };
    }
  }

  return null;
};

export default useSubnetsValidation;
